import React from "react";

// export function convertToHTML1(apiResponse) {
//   // const result = {
//   //   before: "",
//   //   products: [],
//   //   after: "",
//   // };

//   // const paragraph = apiResponse.split("###");
//   // const sections = apiResponse.split("\n---\n");
//   // result.before = paragraph[0];

//   // const productRegex =
//   //   /### (\d+)\.(.*?)\n!\[(.*?)\]\((.*?)\)\n- \*\*Price:\*\* (₹[\d,]+\.\d{2})\n- \*\*Description:\*\* (.*?)\n- \*\*Details:\*\* \[More Info\]\((.*?)\)/gs;
//   // sections.slice(1, -1).forEach((section) => {
//   //   let match;
//   //   while ((match = productRegex.exec(section)) !== null) {
//   //     result.products.push({
//   //       id: match[1],
//   //       name: match[2].trim(),
//   //       image: match[4],
//   //       price: match[5],
//   //       description: match[6],
//   //       details_url: match[7],
//   //     });
//   //   }
//   // });

//   // let afterText = "";
//   // for (let index = 0; index < sections.length; index++) {
//   //   if (
//   //     sections[index].replace(/\n/g, "").trim().substring(0, 3) !== "###" &&
//   //     paragraph[0].replace(/\n/g, "").trim().substring(0, 3) !=
//   //       sections[index].replace(/\n/g, "").trim().substring(0, 3)
//   //   ) {
//   //     afterText += sections[index].trim();
//   //   }
//   // }
//   // result.after = afterText;

//   // if (result.products.length > 0) {
//   //   return (
//   //     <>
//   //       {result.before && (
//   //         <div className="chatbox-message-item-text internal">
//   //           {result.before}
//   //         </div>
//   //       )}
//   //       <div className="product-trail">
//   //         {result.products.map((product, index) => {
//   //           return (
//   //             <div className="product-card" key={index}>
//   //               <a href={product.details_url} target="_top">
//   //                 <div className="main-detail">
//   //                   <figure>
//   //                     <img src={product.image} />
//   //                   </figure>

//   //                   <div className="detail">
//   //                     <div className="title">{product.name}</div>
//   //                     <div className="price">{product.price}</div>
//   //                     <div className="button">Learn More</div>
//   //                   </div>
//   //                 </div>
//   //                 <div className="description">{product.description}</div>
//   //               </a>
//   //             </div>
//   //           );
//   //         })}
//   //       </div>
//   //       {result.after && (
//   //         <div className="chatbox-message-item-text internal">
//   //           {result.after}
//   //         </div>
//   //       )}
//   //     </>
//   //   );
//   // }

//   console.log(
//     "🚀 ~ apiResponse=apiResponse.replace ~ apiResponse:",
//     apiResponse
//   );

//   const productRegex =
//     /\*\*\*Product Information Start\*\*\*(.*?)\*\*\*Product Information End\*\*\*/gs;
//   let products = [];
//   apiResponse = apiResponse.replace(productRegex, (match, content) => {
//     const product = {};
//     console.log("🚀 ~ apiResponse=apiResponse.replace ~ content:", content);

//     // Extract product details using regex
//     product.name = content.match(/#### (.*)/)?.[1] || "";
//     product.model = content.match(/\*\*Model:\*\* (.*)/)?.[1] || "";
//     product.details_url =
//       content.match(/\*\*Link:\*\* \[.*?\]\((.*?)\)/)?.[1] || "";
//     product.price = content.match(/\*\*Price:\*\* (.*)/)?.[1] || "";
//     product.description = content.match(/\*\*Description:\*\* (.*)/)?.[1] || "";
//     product.image = content.match(/!\[.*?\]\((.*?)\)/)?.[1] || "";

//     products.push(product);
//     return ""; // Remove product info from apiResponse
//   });

//   // Replace Markdown-style headers with HTML headers
//   apiResponse = apiResponse
//     .replace(/#### (.*)/g, "<h4>$1</h4>") // Convert '####' to <h4>
//     .replace(/### (.*)/g, "<h3>$1</h3>"); // Convert '###' to <h3>

//   // Convert Markdown-style bold to HTML <strong>
//   apiResponse = apiResponse.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

//   // Convert Markdown-style list to HTML <ul><li>
//   apiResponse = apiResponse.replace(/- (.*)/g, "<li>$1</li>");
//   apiResponse = apiResponse.replace(/(<li>.*<\/li>)/g, "<ul>$1</ul>");

//   // Convert image markdown to HTML <img>
//   apiResponse = apiResponse.replace(
//     /!\[(.*?)\]\((.*?)\)/g,
//     '<img src="$2" alt="$1" style="max-width:100%; height:auto;">'
//   );

//   // Convert link markdown to HTML <a>
//   apiResponse = apiResponse.replace(
//     /\[(.*?)\]\((.*?)\)/g,
//     '<a href="$2" target="_blank">$1</a>'
//   );

//   // Preserve line breaks
//   apiResponse = apiResponse.replace(/\n/g, "<br>");
//   apiResponse = apiResponse.replace(/(<br\s*\/?>\s*)+/g, "<br>");

//   return (
//     <div
//       className="chatbox-message-item-text"
//       dangerouslySetInnerHTML={{ __html: apiResponse }}
//     />
//   );
// }

export function convertToHTML(apiResponse) {
  let productHTMLArray = [];
  let productHTMLArray1 = [];
  let categoryHTMLArray = [];

  let count = 0;
  let catcount = 0;

  apiResponse = apiResponse.replace(/â‚¹/g, "₹");

  // Extract and replace product information
  const productRegex =
    /(?:\*\*\*Product Information Start\*\*\*(.*?)\*\*\*Product Information End\*\*\*|<product_info_start>(.*?)<\/product_info_start>|<product_info_start>(.*?)<\/product_info_end>)/gs;

  apiResponse = apiResponse.replace(
    productRegex,
    (match, content1, content2, content3) => {
      const content = content1 || content2 || content3; // Use whichever format is found
      if (!content) return "";

      // console.log("🚀 ~ convertToHTML ~ content:", content);

      const name =
        content.match(/(?:###(?:\s*\d+\.\s*)?|\- product_name:)\s*(.*)/)?.[1] ||
        "";
      const image = content.match(/\[.*?\]\((.*)\)/)?.[1] || "";
      const price =
        content.match(/(?:\*\*Price:\*\*|\- product_price:)\s*(.*)/)?.[1] || "";
      const description =
        content.match(
          /(?:\*\*Description:\*\*|\- product_short_description:)\s*(.*)/
        )?.[1] || "";

      const details_url =
        content.match(/\*\*Link:\*\* \[.*?\]\((.*?)\)/)?.[1] ||
        content.match(/\- product_link:\s*\[.*?\]\((.*)\)/)?.[1] ||
        "";

      count++;
      // Convert product to HTML format and store in an array
      productHTMLArray.push(`
      <div class="product-card">
        <a href="${details_url}" target="_blank">
          <div class="main-detail">
            ${
              image
                ? `<figure>
              <img src="${image}" alt="${name}" />
            </figure>`
                : ""
            }
            <div class="detail">
              <div class="title">${name}</div>
              <div class="price">${price}</div>
              <div class="button">Learn More</div>
            </div>
          </div>
          <div class="description">${description}</div>
        </a>
      </div>
    `);
      if (count === 1) return "PRODUCT__HTML"; // Remove product text from apiResponse
      return "";
    }
  );

  const categoryRegex =
    /(?:\*\*\*Category Information Start\*\*\*(.*?)\*\*\*Category Information End\*\*\*|<category_info_start>(.*?)<\/category_info_start>|<category_info_start>(.*?)<\/category_info_end>)/gs;

  apiResponse = apiResponse.replace(categoryRegex, (match, content) => {
    if (!content) return "";

    const categoryName = content.match(/\- category_name:\s*(.*)/)?.[1] || "";
    const bannerImage =
      content.match(/\- category_banner_image:\s*!\[.*?\]\((.*?)\)/)?.[1] || "";
    const parentCategory =
      content.match(/\- parent_category:\s*(.*)/)?.[1] || "";
    const description =
      content.match(/\- category_description:\s*(.*)/)?.[1] || "";

    catcount++;
    categoryHTMLArray.push(`
    <div class="product-card category-card">
        <a role="button">
          <div class="main-detail">
            ${
              bannerImage
                ? `<figure>
              <img src="${bannerImage}" alt="${categoryName}" />
            </figure>`
                : ""
            }
          </div>
          <div class="detail">
              <div class="parent-category">${categoryName}</div>
              <div class="title">${parentCategory}</div>
            </div>
          <div class="description">${description}</div>
        </a>
      </div>`);
    if (catcount === 1) return "CATEGORY__HTML"; // Remove product text from apiResponse
    return "";
  });

  // Extract and replace table data
  const tableRegex = /\|(.+?)\|\n\|[-|]+\|\n((?:\|.+?\|\n)+)/gs;
  apiResponse = apiResponse.replace(tableRegex, (match, headers, rows) => {
    const headerArray = headers
      .split("|")
      .map((h) => h.trim())
      .filter(Boolean);
    const rowArray = rows
      .trim()
      .split("\n")
      .map((row) =>
        row
          .split("|")
          .map((cell) => cell.trim())
          .filter(Boolean)
      );

    let tableJSON = [];
    rowArray.forEach((row) => {
      let rowData = {};
      headerArray.forEach((header, index) => {
        rowData[header] = row[index] || "";
      });
      tableJSON.push(rowData);
    });

    // Convert JSON to HTML table
    let tableHTML = `<div class="table-container"><table class="comparison-table" cellspacing="0" cellpadding="0"><thead><tr>`;
    headerArray.forEach((header) => {
      tableHTML += `<th>${header}</th>`;
    });
    tableHTML += `</tr></thead><tbody>`;
    tableJSON.forEach((row) => {
      tableHTML += `<tr>`;
      headerArray.forEach((header) => {
        tableHTML += `<td>${row[header]}</td>`;
      });
      tableHTML += `</tr>`;
    });
    tableHTML += `</tbody></table></div>`;

    return tableHTML;
  });

  // Convert remaining Markdown to HTML
  apiResponse = apiResponse
    .replace(/#### (.*)/g, "<h4>$1</h4>")
    .replace(/### (.*)/g, "<h3>$1</h3>")
    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
    .replace(/- (.*)/g, "<li>$1</li>")
    .replace(/(<li>.*<\/li>)/g, "<ul>$1</ul>")
    .replace(
      /!\[(.*?)\]\((.*?)\)/g,
      '<img src="$2" alt="$1" style="max-width:100%; height:auto;">'
    )
    .replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank">$1</a>')
    .replace(/\n/g, "<br>")
    .replace(/(<br\s*\/?>\s*)+/g, "<br>");

  // Wrap all products in a single div if products exist
  if (productHTMLArray.length > 0) {
    const productSection = `<div class="product-trail">${productHTMLArray.join(
      ""
    )}</div>`;
    apiResponse = apiResponse.replace("PRODUCT__HTML", productSection);
  }

  if (productHTMLArray1.length > 0) {
    const productSection = `<div class="product-trail">${productHTMLArray1.join(
      ""
    )}</div>`;
    apiResponse = apiResponse.replace("PRODUCT__HTML_2", productSection);
  }

  if (categoryHTMLArray.length > 0) {
    const categorySection = `<div class="product-trail">${categoryHTMLArray.join(
      ""
    )}</div>`;
    apiResponse = apiResponse.replace("CATEGORY__HTML", categorySection);
  }

  return {
    html: (
      <div
        className="chatbox-message-item-text"
        dangerouslySetInnerHTML={{ __html: apiResponse }}
      />
    ),
    htmlString: `<div class="chatbox-message-item-text">${apiResponse}</div>`,
  };
}

export const getAPIEndpoint = (token, save = false) => {
  if (save) {
    switch (token) {
      case "essco":
        return "https://essco-admin.agilisplus.ai/api";
      case "haier":
        return "https://haier-admin-staging.agilisplus.ai/api";
      case "glen":
        return "https://glen-admin-staging.agilisplus.ai/api";
      case "acer":
        return "https://acer-admin-staging.agilisplus.ai/api";
      default:
        return "https://glen-admin-staging.agilisplus.ai/api";
    }
  }
  switch (token) {
    case "essco":
      return "https://agents.agilisplus.ai/essco/api";
    case "haier":
      return "https://agents.agilisplus.ai/haier/api";
    case "glen":
      return "https://agents.agilisplus.ai/glen/api";
    case "acer":
      return "https://agents.agilisplus.ai/acer/api";
    case "raymond":
      return "https://agents.agilisplus.ai/raymond/api";
    default:
      return "https://agents.agilisplus.ai/raymond/api";
    //      return "https://agents.agilisplus.ai/glen/api";
    //    return "http://127.0.0.1:5001/api";
  }
};

export const getQuestions = (token) => {
  switch (token) {
    case "essco":
      return [
        "⁠What products are offered by Essco Bathware?",
        "⁠Show me showers.",
      ];
    case "haier":
      return [
        "What products does Haier India offer?",
        "Tell me about Smart TVs under ₹50,000",
      ];
    case "glen":
      return [
        "⁠Does Glen offer auto-clean chimneys, and how do they work?",
        "What is the difference between Glen built-in hobs and regular gas stoves?",
        "⁠What is the difference between brass burners and aluminum burners in Glen gas stoves?",
      ];
    case "raymond":
      return [
        "Formal shirts under INR 5000",
        "Show me some shirts for a corporate conference occasion",
        "Looking for a white slim fit shirt",
      ];
    case "acer":
      return [
        "Top laptops under INR 60,000",
        "Suggest some gaming laptops in Acer",
        "Looking for 16GB RAM Laptops",
      ];
    default:
      return [
        "Formal shirts under INR 5000",
        "Show me some shirts for a corporate conference occasion",
        "Looking for a white slim fit shirt",
      ];
  }
};

export const getMessage = (token) => {
  switch (token) {
    case "essco":
      return "Hello, I am your virtual assistant. How may I help you today?<br/>";

    case "haier":
      return "Hello! I'm Aura, your friendly AI assistant by Haier. How can I brighten your day?";

    case "glen":
      return "Hello! I'm Glen, your friendly AI assistant by Glen Appliances. How can I brighten your day?";

    case "raymond":
      return "Hello, I'm Ray, a friendly AI assistant by Raymond.";

    case "acer":
      return "Hello, I'm Acer, a friendly AI by Acer Inc.";

    default:
      return "Hello, I'm Ray, a friendly AI assistant by Raymond.";
  }
};

export const setCookie = (name, value, daysToExpire) => {
  const date = new Date();
  date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);

  const data = {
    value,
    expires: date.getTime(), // Store expiry timestamp
  };

  localStorage.setItem(name, JSON.stringify(data));
};

export const getCookie = (name) => {
  const storedData = JSON.parse(localStorage.getItem(name));

  if (storedData) {
    const now = new Date().getTime();
    if (now > storedData.expires) {
      localStorage.removeItem(name);
      return "";
    }
    return storedData.value;
  }

  return "";
};

export const fetchData = async (tokenName, url, data, token = false) => {
  let headers = { "Content-Type": "application/json" };
  if (tokenName === "essco") {
    if (token) {
      headers = {
        ...headers,
        ...{
          Authorization:
            "Bearer 3b470f38aa3deb01bf6700b09542a06c1ccdbc4331fe5be6781843cf55b3e575866a6c6833df55934ab8c598d06997a38d4463f28355428a32668b381927f7c3996a22256baa40a421ad36dbdeea7ab88e9541f0ba1158e65ebcdf6442d71f2134468d7eb835aebe75c5b4e429ffb901fa1efffd8f40e7742d151a07c949e86c",
        },
      };
    }
    const resp = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    return resp;
  } else if (tokenName === "glen") {
    if (token) {
      headers = {
        ...headers,
        ...{
          Authorization:
            "Bearer e3f0e607dac9b9b4e549762126fcc411d95214cf7e55134ec3cd1b3874d857e4ed602c41803d9c307b9b270b14b5babbcc9762ad2022a5dadf0f6005136034e088bbfda1a2d10d7b6cd9df2e445747036e54cd2bd24e5a70105c541ada27e0ef741a4202ec50d9f2a133344e1c7f9e4c74505c2b8ce3e8e35f5607924ef1ee40",
        },
      };
    }
    const resp = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    return resp;
  } else if (tokenName === "haier") {
    if (token) {
      headers = {
        ...headers,
        ...{
          Authorization:
            "Bearer 4847bdeb21ff7c0afb5abf8050ea808e138798899aae0c3aceb510601e50dde94fc27d31692cf1c190a67e638c33a815800a556ba8a0e084cc8093f87f2c4a4b01683f1a366f858e657ebd29807a6c46b80d34f050f142e01cd90f12ce9a7d8271fc1ff1a690b1d1d0d94892b223940090861790f266f78e5f9057b08ce10335",
        },
      };
    }
    const resp = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    return resp;
  } else if (tokenName === "acer") {
    if (token) {
      headers = {
        ...headers,
        ...{
          Authorization:
            "Bearer 30a703d6c5629d91adf993c2e8083f562c7032cd4ba83ca39ebacddd5dbff4c5344ab374e5e217125c0e8a8d78dc98059d60493cb85c9fcbfada41d94ee68f2aae5f73ebbc555bcea857c3d4ce8083bad04d19c99111af1f25f91326be752cb117a818ff693dda81d9e52909f79f1b502279cea8da6090aeca1225265225fc2b",
        },
      };
    }
    const resp = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    return resp;
  } else {
    return new Promise((resolve) => {
      resolve();
    });
  }
};

export async function copyContent(text) {
  try {
    await navigator.clipboard.writeText(text);
    alert("Content copied to clipboard");
    /* Resolved - text copied to clipboard successfully */
  } catch (err) {
    console.error("Failed to copy: ", err);
    /* Rejected - text failed to copy to the clipboard */
  }
}

const mobile = {
  Android: () =>
    !navigator.userAgent || navigator.userAgent.match(/Android/i) != null,
  iOS: () =>
    !navigator.userAgent ||
    navigator.userAgent.match(/iPhone|iPad|iPod/i) != null,
  Googlebot: () =>
    !navigator.userAgent || navigator.userAgent.match(/Googlebot/i) != null,
  Amp: () => {
    if (typeof navigator.userAgent === "undefined") {
      return false;
    }
    if (
      typeof window !== "undefined" &&
      window.location.href.indexOf("/amp/") > -1
    ) {
      return true;
    }
    return navigator.userAgent === "Amp";
  },
  any: () => {
    if (mobile.Android() || mobile.iOS()) {
      return true;
    }
    return false;
  },
};

export const isMobile = (userAgent) => {
  const getMobile = () =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );

  return getMobile();
};
